import { render } from "./ApiConfig.vue?vue&type=template&id=4ad3d7d0&scoped=true"
import script from "./ApiConfig.vue?vue&type=script&lang=js"
export * from "./ApiConfig.vue?vue&type=script&lang=js"

import "./ApiConfig.vue?vue&type=style&index=0&id=4ad3d7d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad3d7d0"]])

export default __exports__